import {
  axiosInstance
} from './axiosInstance';
import { handleErrorResponse } from '../../helpers/handleErrorResponse';

export const userVerification = async (data) => {
  let response;
  try {
    response = await axiosInstance.post('/user-verification', data);
  } catch (err) {
    response = handleErrorResponse(err, data);
  }

  return response;
};